import { Router, href as originalHref } from 'stencil-router-v2';
import { Page, Pages, Route, SpecialPage } from '../configuration/pages';
import { ClickEventData } from '../components';
import { EventEmitter } from '@stencil/core';

export function getPageForRoute(route: Route): null | Page {
  return (Object.values(Pages)
    .filter(page => page?.route === route)
    .shift() ?? null) as null | Page;
}

export function getCurrentPage(route: Route = window.location.pathname as Route): SpecialPage | Page {
  return getPageForRoute(normalizePath(route) as Route) ?? Pages.NotFound;
}

export function isActiveRoute(page: Page, activePage: SpecialPage | Page = null): boolean {
  let pageToCheck;

  if (activePage === null) {
    pageToCheck = normalizePath(window.location.pathname);
  } else {
    pageToCheck = activePage.route;
  }

  return pageToCheck === page.route;
}

export function isActiveParentRoute(page: Page, activePage: SpecialPage | Page = null): boolean {
  let pageToCheck;

  if (activePage === null) {
    pageToCheck = normalizePath(window.location.pathname);
  } else {
    pageToCheck = activePage.route;
  }

  // if if the route is exactly the same, or a subpage
  return typeof pageToCheck === 'string' && pageToCheck.indexOf(page.route) === 0;
}

export function normalizePath(path: string): string {
  return path === '/' ? '/' : path.replace(/\/$/, '');
}

export function prepareToUnloadHref(
  hrefString: string,
  router?: Router,
  active: boolean = false,
  clicked?: EventEmitter<ClickEventData>,
  revealDelay?: boolean,
): {
  href: string;
  onClick: (ev: MouseEvent) => void;
} {
  let { href, onClick } = originalHref(hrefString, router);

  const oldOnClick = onClick;
  onClick = (e: MouseEvent) => {
    e.preventDefault();

    if (active) {
      return;
    }

    if (revealDelay) {
      window.rudyRevealDelay = true;
    }

    if (clicked) {
      clicked.emit({ name: '' });
    }

    window.dispatchEvent(new CustomEvent('rudy:unloadpage', {}));

    window.setTimeout(
      () => {
        oldOnClick(e);
      },
      revealDelay ? 0 : 500,
    );
  };

  return { href, onClick };
}
